import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import getFilteredOptions from './helpers/getFilteredOptions';
import SelectPlaceholder from '../SelectPlaceholder';
import getMenuItems from '@/actions/getMenuItemFilterOptions';
import Dropdown from '@/external/components/Dropdown';
import MenuItem from '@/external/components/MenuItem';

type Props = {
  type: 'categories' | 'providers';
  menuItem?: string;
  theme?: string;
};

const SelectFilterOptions: FC<Props> = ({ type, menuItem, theme }) => {
  const [options, setOptions] = useState<FilterOption[]>([]);
  const pathname = usePathname();

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const initOptions = await getMenuItems({ type, menuItem, theme });
        const filteredOptions = getFilteredOptions(
          pathname,
          initOptions || [],
          type,
        );
        setOptions(filteredOptions);
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    };

    fetchOptions();
  }, [type, menuItem, pathname, theme]);

  if (options.length === 0) {
    return <SelectPlaceholder />;
  }
  return (
    <>
      {options.map((item) => (
        <Dropdown.Option value={item.value} key={item.value}>
          {({ selected, active }) => (
            <MenuItem isActive={active} isSelected={selected}>
              <MenuItem.Checkbox isSelected={selected} />
              <MenuItem.Title>
                <span className="text-moon-14 text-trunks">{item.label}</span>
              </MenuItem.Title>
            </MenuItem>
          )}
        </Dropdown.Option>
      ))}
    </>
  );
};
export default SelectFilterOptions;
